import { styled } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';

import { useTranslation } from '../../../hooks';
import { useAppSelector } from '../../../reducer/hooks';
import { selectIsMobileView } from '../../../reducer/mediaSlice';

const StyledInput = styled(OutlinedInput)(
  () => `
    flex: 1;
    height: 38px !important;
    font-size: 16px;
    border-radius: 4px;
    background-color: #F9F9F9 !important;
    border: 1px solid #F9F9F9;

  
    &:hover {
      border: 1px solid #F9F9F9 !important;
      outline: 0 !important;
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: #DDE1E3 !important;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #DDE1E3 !important;
    }

    &.Mui-disabled {
      background-color: #3a3a3a !important;
      border: 1px solid #555555 !important;
      color: #888888 !important;
      cursor: not-allowed !important;
      opacity: 0.6;
    }

    &.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: #555555 !important;
    }

    &.Mui-disabled:hover {
      border: 1px solid #555555 !important;
    }
  
    // firefox
    &:focus-visible {
      outline: 0 !important;
    }
  );
  `
);

const RemarksTextArea = ({
  value,
  onChange,
  isDisabled,
}: {
  value: string;
  onChange: (e: any) => void;
  isDisabled?: boolean;
}) => {
  const { tc } = useTranslation();
  const isMobile = useAppSelector(selectIsMobileView);

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          flex: '1',
          padding: isMobile ? '24px 0 ' : '24px',
          ...(isMobile && { width: '90%' }),
        }}
      >
        <div style={{ marginRight: '24px', fontSize: '16px' }}>{tc('remarks')}</div>
        <StyledInput value={value} onChange={onChange} disabled={isDisabled} />
      </div>
    </>
  );
};

export default RemarksTextArea;
